export default __webpack_public_path__ + "static/media/winner_7.83487eaf.jpg";